<template>
  <div>
    <div ref="gallery" class="swiper-container">
      <div class="swiper-wrapper">
        <div
          ref="zoomerWrapper"
          v-for="(slide, index) in slides"
          :key="`large-${index}`"
          :zoom="slide.zoom"
          class="swiper-slide sw-Gallery_Slide"
        >
          <Zoomer
            :active="galleryInstance && galleryInstance.activeIndex === index"
            :base_image="slide.large"
            :zoom_image="slide.zoom"
            :alt="slide.alt"
            image_class="sw-Gallery_Img"
          />
        </div>
      </div>
    </div>
    <div ref="galleryThumb" v-if="slides.length > 1" class="my-3 swiper-container">
      <div class="swiper-wrapper thumbs-wrapper">
        <div
          v-for="(slide, index) in slides"
          :key="`thumb-${index}`"
          :class="{ 'thumb-visible': chosenVariant ? slide.variant === chosenVariant : true }"
          class="thumb-item swiper-slide"
        >
          <img :src="slide.thumb" :alt="`thumb-${index}`" class="thumb-image img-fluid" />
        </div>
      </div>
    </div>
  </div>
</template>
<script>
import Swiper from "swiper/js/swiper.min.js";
import Zoomer from "./Zoomer.vue";
import { LuminousGallery } from "luminous-lightbox";

import { mapGetters } from "vuex";

export default {
  name: "ProductGallery",
  components: {
    Zoomer,
  },
  props: {
    slides: {
      type: Array,
      required: true,
    },
  },
  data() {
    return {
      activeIndex: 0,
      galleryInstance: undefined,
    };
  },
  computed: {
    ...mapGetters({
      chosenVariant: "variantPicker/chosenVariant",
    }),
    firstSlideWithSelectedVariant() {
      return this.slides.findIndex(slide => slide.variant === this.chosenVariant);
    },
  },
  watch: {
    firstSlideWithSelectedVariant(value) {
      this.galleryInstance.slideTo(value);
    },
  },
  mounted() {
    if (this.slides?.length) {
      this.thumbInstance = this.initThumbsInstance();
      this.galleryInstance = this.initSwiperInstance();
      this.lightboxInstance = this.initLuminousInstance();

      if (this.thumbInstance) {
        this.galleryInstance.controller.control = this.thumbInstance;
        this.thumbInstance.controller.control = this.galleryInstance;
      }
    }
  },
  beforeDestroy() {
    this.galleryInstance.destroy();
    this.thumbInstance.destroy();
    this.lightboxInstance.destroy();
  },
  methods: {
    initLuminousInstance() {
      return new LuminousGallery(
        this.$refs.zoomerWrapper,
        {},
        {
          sourceAttribute: "zoom",
        }
      );
    },
    initSwiperInstance() {
      return new Swiper(this.$refs.gallery, {
        spaceBetween: 0,
        watchOverflow: true,
      });
    },
    initThumbsInstance() {
      if (this.slides.length > 1) {
        return new Swiper(this.$refs.galleryThumb, {
          spaceBetween: 4,
          centeredSlides: true,
          slidesPerView: 8,
          touchRatio: 0.2,
          slideToClickedSlide: true,
          on: {
            slideChangeTransitionEnd: () => {
              this.thumbInstance.updateSlidesClasses();
            },
          },
        });
      }
    },
  },
};
</script>
<style lang="scss">
@import "~swiper/css/swiper";
@import "~styles/global";
@import "luminous-lightbox/dist/luminous-basic.css";

.thumb-image {
  flex: 0 0 auto;
  max-height: 60px;
}

.swiper-container {
  display: block;
}

.thumb-item {
  display: flex;
  align-items: center;
  justify-content: center;
  border: $width-border-thin solid transparent;
  padding: $spacer / 6;
  border-radius: $border-radius;
  opacity: 0.5;
  width: auto;
  height: auto;
  cursor: pointer;
  transition: border-color $transition-duration;

  &:hover {
    border-color: rgba($gray-800, 0.5);
  }
}

.thumb-item.swiper-slide-active {
  border-color: $gray-800;
  opacity: 1;
}

.thumbs-wrapper {
  align-items: stretch;
}

.thumb-item.thumb-visible {
  opacity: 1;
}

.sw-Gallery_Slide {
  display: flex;
  overflow: hidden;
  justify-content: center;
  height: auto;
  min-height: $min-height-product-image-xs;

  @media (min-width: $screen-sm-min) {
    min-height: $min-height-product-image;
  }
}

.lum-lightbox {
  z-index: $zi-highest;

  .lum-img {
    max-width: 100%;
  }
}
</style>
